"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountSortByEnum = exports.DiscountUsageTypeEnum = exports.DiscountOnEnum = exports.InvoiceDiscountOnEnum = exports.DiscountTypeEnum = void 0;
var DiscountTypeEnum;
(function (DiscountTypeEnum) {
    DiscountTypeEnum["MANUAL"] = "manual";
    DiscountTypeEnum["FIXED"] = "fixed";
    DiscountTypeEnum["ENTITLEMENT_GROUP"] = "entitlement_group";
})(DiscountTypeEnum = exports.DiscountTypeEnum || (exports.DiscountTypeEnum = {}));
var InvoiceDiscountOnEnum;
(function (InvoiceDiscountOnEnum) {
    InvoiceDiscountOnEnum["INVOICE"] = "invoice";
    InvoiceDiscountOnEnum["LINE_ITEM"] = "line_item";
})(InvoiceDiscountOnEnum = exports.InvoiceDiscountOnEnum || (exports.InvoiceDiscountOnEnum = {}));
var DiscountOnEnum;
(function (DiscountOnEnum) {
    DiscountOnEnum["ALL"] = "all";
    DiscountOnEnum["ITEM"] = "item";
})(DiscountOnEnum = exports.DiscountOnEnum || (exports.DiscountOnEnum = {}));
var DiscountUsageTypeEnum;
(function (DiscountUsageTypeEnum) {
    DiscountUsageTypeEnum["BY_PRODUCT_USER"] = "by_product_user";
    DiscountUsageTypeEnum["BY_PAYING_USER"] = "by_paying_user";
    DiscountUsageTypeEnum["DEFAULT"] = "default";
})(DiscountUsageTypeEnum = exports.DiscountUsageTypeEnum || (exports.DiscountUsageTypeEnum = {}));
var DiscountSortByEnum;
(function (DiscountSortByEnum) {
    DiscountSortByEnum["CODE"] = "code";
    DiscountSortByEnum["NAME"] = "name";
    DiscountSortByEnum["ACTIVE"] = "active";
    DiscountSortByEnum["FAVORITE"] = "favorite";
    DiscountSortByEnum["PUBLIC"] = "public";
})(DiscountSortByEnum = exports.DiscountSortByEnum || (exports.DiscountSortByEnum = {}));
//# sourceMappingURL=discount.enums.js.map